import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { PagedData } from '../models/paging/paged-data';
import { Page } from '../models/paging/page';
import { ServerData } from '../models/paging/server-data';

import { AuthService } from '../services/auth.service';
import * as moment from 'moment';
import { environment } from '../../environments/environment';

@Injectable()
export class CylHistoryService {
  constructor(private http: HttpClient, private authService: AuthService) { }

  public getResults(page: Page, cylinder_Id: number, quick_Search: string): Promise<PagedData<any>> {
    const pagedData = new PagedData<any>();

    return new Promise((resolve, reject) => {
      if (page.sortBy == undefined || page.sortBy == '') { page.sortBy = 'Inspected_At'; }
      if (page.sortOrder == undefined || page.sortOrder == '') { page.sortOrder = 'desc'; }

      let params = '&cylinder_Id=' + cylinder_Id
      params +='&quick_Search=' + quick_Search
                            
      this.http.get<ServerData>(environment.apiUrl + 'distribution/GetCylHistory?size=' + page.size + '&pageNumber=' + page.pageNumber + '&sortBy=' + page.sortBy + '&sortOrder=' + page.sortOrder + params).subscribe(data => {
        page.totalElements = data.total;
        page.totalPages = page.totalElements / page.size;
        console.log("Data Retrieved")
        console.log(data);
        for (let i = 0; i < data.data.length; i++) {
          const jsonObj = data.data[i];
          pagedData.data.push(jsonObj);
        }
        
        pagedData.page = page;
        resolve(pagedData);

      }, error => {
        reject();
      });
    });
  }

  converBase64toBlob(content, contentType) {
    contentType = contentType || '';
    let sliceSize = 512;
    let byteCharacters = window.atob(content); //method which converts base64 to binary
    let byteArrays = [
    ];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      let slice = byteCharacters.slice(offset, offset + sliceSize);
      let byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      let byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    let blob = new Blob(byteArrays, {
      type: contentType
    }); //statement which creates the blob
    return blob;
  }


  public getExcel(cylinder_Id: number): Promise<any> {

    return new Promise((resolve, reject) => {

      let params = '?cylinder_Id=' + cylinder_Id;

      this.http.get<any>(environment.apiUrl + 'distribution/GetCylHistoryExcel' + params).subscribe(data => {
        let blob = this.converBase64toBlob(data, 'application/vnd.ms-excel');
        resolve(blob);
      }, error => {
        console.log(error);
        reject();
      });
    });
  }

  public getAllInspections(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.get<any>('/api/inspection/getallInspections').subscribe(data => {
        resolve(data);
      }, error => {
        reject();
      });
    });
  }

  public getAllInspectionsEngineers(): Promise<any> {

    return new Promise((resolve, reject) => {
      this.http.get<any>('/api/inspection/getAllInspectionsEngineers').subscribe(data => {
        
        resolve(data);
        
      }, error => {
        reject();
      });
    });
  }



}
